import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { TreatmentSchedulesResponse } from "../schemas/Treatment";

export const queryKeyPrefix = "getTreatmentSchedules";
type QueryKey = [typeof queryKeyPrefix, GetTreatmentSchedulesParams];
const getTreatmentSchedulesQueryKey = (params: GetTreatmentSchedulesParams): QueryKey => [queryKeyPrefix, params];

export interface GetTreatmentSchedulesParams {
  group?: string;
  limit?: number;
  page?: number;
  search?: string;
}

export const useGetTreatmentSchedules = (
  params: GetTreatmentSchedulesParams = {},
  options?: UseQueryOptions<TreatmentSchedulesResponse, Error, TreatmentSchedulesResponse, QueryKey>
): UseQueryResult<TreatmentSchedulesResponse, Error> => {
  const client = useApiClient();
  return useQuery(
    getTreatmentSchedulesQueryKey(params),
    () => {
      return client.getTreatmentSchedules(params);
    },
    options
  );
};
